import { lazy } from 'react';

// ===================== PUBLIC PAGES =====================
export const HomePage = lazy(() => import('@/pages/HomePage'));
export const AboutUs = lazy(() => import('@/pages/AboutUs'));
export const BusinessDirectory = lazy(() => import('@/pages/BusinessDirectory'));
export const BusinessMap = lazy(() => import('@/pages/BusinessMap'));
export const BusinessDetail = lazy(() => import('@/pages/BusinessDetail'));
export const AddBusiness = lazy(() => import('@/pages/AddBusiness'));
export const AIAssistant = lazy(() => import('@/pages/AIAssistant'));
export const Events = lazy(() => import('@/pages/Events'));
export const SubmitEvent = lazy(() => import('@/pages/SubmitEvent'));
export const Resources = lazy(() => import('@/pages/Resources'));
export const LouisianaBizResources = lazy(() => import('@/pages/LouisianaBizResources'));
export const GlobalBizResources = lazy(() => import('@/pages/GlobalBizResources'));
export const MentalHealthTips = lazy(() => import('@/pages/MentalHealthTips'));
export const GratitudeWall = lazy(() => import('@/pages/GratitudeWall'));
export const Grants = lazy(() => import('@/pages/Grants'));
export const CommunityFeed = lazy(() => import('@/pages/CommunityFeed'));
export const Shop = lazy(() => import('@/pages/Shop'));
export const Cart = lazy(() => import('@/pages/Cart'));
export const CheckoutSuccess = lazy(() => import('@/pages/CheckoutSuccess'));
export const VirtualBooths = lazy(() => import('@/pages/VirtualBooths'));
export const BoothDetail = lazy(() => import('@/pages/BoothDetail'));
export const BoothDashboard = lazy(() => import('@/pages/BoothDashboard'));
export const CreateBooth = lazy(() => import('@/pages/CreateBooth'));
export const Donate = lazy(() => import('@/pages/Donate'));
export const Contact = lazy(() => import('@/pages/Contact'));
export const Blog = lazy(() => import('@/pages/Blog'));
export const BlogPost = lazy(() => import('@/pages/BlogPost'));
export const Services = lazy(() => import('@/pages/Services'));
export const WhyDowUrk = lazy(() => import('@/pages/WhyDowUrk'));
export const Partnerships = lazy(() => import('@/pages/Partnerships'));
export const PressRelease = lazy(() => import('@/pages/PressRelease'));
export const FundraiserPage = lazy(() => import('@/pages/FundraiserPage'));
export const PhotographySuite = lazy(() => import('@/pages/PhotographySuite'));
export const RealEstateSuite = lazy(() => import('@/pages/RealEstateSuite'));
export const RestaurantSuite = lazy(() => import('@/pages/RestaurantSuite'));
export const ConsultantSuite = lazy(() => import('@/pages/ConsultantSuite'));
export const IndustrySuites = lazy(() => import('@/pages/IndustrySuites'));

// ===================== LEGAL PAGES =====================
export const Certifications = lazy(() => import('@/pages/Certifications'));
export const TakedownPolicy = lazy(() => import('@/pages/TakedownPolicy'));
export const RefundPolicy = lazy(() => import('@/pages/RefundPolicy'));
export const TermsOfUse = lazy(() => import('@/pages/TermsOfUse'));
export const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'));
export const TermsOfService = lazy(() => import('@/pages/TermsOfService'));
export const CompliancePage = lazy(() => import('@/pages/CompliancePage'));
export const DataRequestPage = lazy(() => import('@/pages/DataRequestPage'));
export const ContentRightsAgreement = lazy(() => import('@/pages/ContentRightsAgreement'));

// ===================== AUTH PAGES =====================
export const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'));
export const Login = lazy(() => import('@/pages/Login'));
export const Register = lazy(() => import('@/pages/Register'));

// ===================== ADMIN PAGES =====================
export const AdminResourceManagement = lazy(() => import('@/pages/AdminResourceManagement'));
export const AdminShopManagement = lazy(() => import('@/pages/AdminShopManagement'));
export const AdminBusinessManagement = lazy(() => import('@/pages/AdminBusinessManagement'));
export const AdminEventManagement = lazy(() => import('@/pages/AdminEventManagement'));
export const AdminBlessingModeration = lazy(() => import('@/pages/AdminBlessingModeration'));
export const AdminBlogManagement = lazy(() => import('@/pages/AdminBlogManagement'));
export const AdminEventSubmissions = lazy(() => import('@/pages/AdminEventSubmissions'));
export const AdminDashboard = lazy(() => import('@/pages/AdminDashboard'));
export const AdminHubDashboard = lazy(() => import('@/pages/admin/AdminHubDashboard'));
export const AdminCRM = lazy(() => import('@/pages/AdminCRM'));
export const AdminVolunteers = lazy(() => import('@/pages/AdminVolunteers'));
export const AdminVideoSettings = lazy(() => import('@/pages/AdminVideoSettings'));
export const AdminNewsletter = lazy(() => import('@/pages/AdminNewsletter'));
export const AdminCampaigns = lazy(() => import('@/pages/AdminCampaigns'));
export const AdminSuccessStories = lazy(() => import('@/pages/AdminSuccessStories'));
export const AdminServiceOrders = lazy(() => import('@/pages/admin/AdminServiceOrders'));
export const AdminDailyDigest = lazy(() => import('@/pages/admin/AdminDailyDigest'));
export const AdminContentGenerator = lazy(() => import('@/pages/admin/AdminContentGenerator'));
export const AdminAIAnalysis = lazy(() => import('@/pages/admin/AdminAIAnalysis'));
export const AdminAIAgents = lazy(() => import('@/pages/admin/AdminAIAgents'));
export const AdminLMS = lazy(() => import('@/pages/admin/AdminLMS'));
export const AdminGeneralVolunteers = lazy(() => import('@/pages/admin/AdminGeneralVolunteers'));
export const AdminOnboardingEmails = lazy(() => import('@/pages/admin/AdminOnboardingEmails'));
export const AdminEmailABTesting = lazy(() => import('@/pages/admin/AdminEmailABTesting'));
export const AdminEmailTemplates = lazy(() => import('@/pages/admin/AdminEmailTemplates'));
export const AdminTranslations = lazy(() => import('@/pages/admin/AdminTranslations'));
export const AdminAutomationRules = lazy(() => import('@/pages/admin/AdminAutomationRules'));
export const StripeTestDashboard = lazy(() => import('@/pages/admin/StripeTestDashboard'));
export const AdminRevenue = lazy(() => import('@/pages/admin/AdminRevenue'));
export const AdminEngagement = lazy(() => import('@/pages/admin/AdminEngagement'));
export const AdminReports = lazy(() => import('@/pages/admin/AdminReports'));
export const AdminBadgeAward = lazy(() => import('@/pages/admin/AdminBadgeAward'));
export const AdminBadgeTriggers = lazy(() => import('@/pages/admin/AdminBadgeTriggers'));
export const AdminGDPR = lazy(() => import('@/pages/admin/AdminGDPR'));
export const AdminServiceProviders = lazy(() => import('@/pages/admin/AdminServiceProviders'));
export const AdminEnterprise = lazy(() => import('@/pages/admin/AdminEnterprise'));
export const AdminCapital = lazy(() => import('@/pages/admin/AdminCapital'));
export const AdminROTWAnalytics = lazy(() => import('@/pages/admin/AdminROTWAnalytics'));
export const AdminPremiumSales = lazy(() => import('@/pages/admin/AdminPremiumSales'));
export const AdminUserManagement = lazy(() => import('@/pages/admin/AdminUserManagement'));
export const AdminFiles = lazy(() => import('@/pages/admin/AdminFiles'));
export const AdminInterestForm = lazy(() => import('@/pages/admin/AdminInterestForm'));
export const SocialDesk = lazy(() => import('@/pages/admin/SocialDesk'));
export const SocialVoice = lazy(() => import('@/pages/admin/SocialVoice'));
export const SocialAnalytics = lazy(() => import('@/pages/admin/SocialAnalytics'));
export const JoinInterest = lazy(() => import('@/pages/JoinInterest'));
export const AdminDonations = lazy(() => import('@/pages/admin/AdminDonations'));
export const AdminNewsletterSubscribers = lazy(() => import('@/pages/admin/AdminNewsletterSubscribers'));
export const AdminAnalyticsOverview = lazy(() => import('@/pages/admin/AdminAnalyticsOverview'));
export const AdminEmailSequences = lazy(() => import('@/pages/admin/AdminEmailSequences'));
export const AdminCohortTracking = lazy(() => import('@/pages/admin/AdminCohortTracking'));
export const AdminDemographics = lazy(() => import('@/pages/admin/AdminDemographics'));
export const AdminSEEDWallets = lazy(() => import('@/pages/admin/AdminSEEDWallets'));
export const AdminFeedback = lazy(() => import('@/pages/admin/AdminFeedback'));
export const AdminWhiteLabel = lazy(() => import('@/pages/admin/AdminWhiteLabel'));
export const AdminRecipeApproval = lazy(() => import('@/pages/admin/AdminRecipeApproval'));
export const AdminGlobalKitchen = lazy(() => import('@/pages/admin/AdminGlobalKitchen'));

// ===================== TENANT / WHITE-LABEL =====================
export const SEEDTokenDashboard = lazy(() => import('@/pages/SEEDTokenDashboard'));
export const CommunityFeedback = lazy(() => import('@/pages/CommunityFeedback'));
export const CreativeProPricing = lazy(() => import('@/pages/CreativeProPricing'));
export const TenantPortal = lazy(() => import('@/pages/TenantPortal'));
export const TenantSettings = lazy(() => import('@/pages/TenantSettings'));
export const TenantLogin = lazy(() => import('@/pages/TenantLogin'));
export const TenantForgotPassword = lazy(() => import('@/pages/TenantForgotPassword'));
export const TenantResetPassword = lazy(() => import('@/pages/TenantResetPassword'));
export const AcceptInvite = lazy(() => import('@/pages/AcceptInvite'));

// ===================== FUNNEL / PREMIUM =====================
export const FreeBlueprint = lazy(() => import('@/pages/FreeBlueprint'));
export const BusinessBuilder = lazy(() => import('@/pages/BusinessBuilder'));
export const WorkforceProgram = lazy(() => import('@/pages/WorkforceProgram'));
export const DonorWall = lazy(() => import('@/pages/DonorWall'));
export const Membership = lazy(() => import('@/pages/Membership'));
export const MembershipSuccess = lazy(() => import('@/pages/MembershipSuccess'));
export const PremiumHub = lazy(() => import('@/pages/PremiumHub'));
export const GrantMatchAlerts = lazy(() => import('@/pages/GrantMatchAlerts'));
export const PremiumAnalytics = lazy(() => import('@/pages/PremiumAnalytics'));
export const ComplianceCertification = lazy(() => import('@/pages/ComplianceCertification'));
export const PrioritySupport = lazy(() => import('@/pages/PrioritySupport'));
export const DonationSuccess = lazy(() => import('@/pages/DonationSuccess'));
export const TokenDashboard = lazy(() => import('@/pages/TokenDashboard'));
export const CryptoDonation = lazy(() => import('@/pages/CryptoDonation'));
export const ReferralProgram = lazy(() => import('@/pages/ReferralProgram'));
export const DeFiLending = lazy(() => import('@/pages/DeFiLending'));
export const GrantConcierge = lazy(() => import('@/pages/GrantConcierge'));
export const ComplianceConcierge = lazy(() => import('@/pages/ComplianceConcierge'));
export const InstitutionalLicensing = lazy(() => import('@/pages/InstitutionalLicensing'));
export const FederalContracting = lazy(() => import('@/pages/FederalContracting'));
export const SOPBuilder = lazy(() => import('@/pages/SOPBuilder'));
export const NonprofitOps = lazy(() => import('@/pages/NonprofitOps'));
export const AdminTickerCMS = lazy(() => import('@/pages/AdminTickerCMS'));
export const MentalWealthAudit = lazy(() => import('@/pages/MentalWealthAudit'));
export const MentalWealthResources = lazy(() => import('@/pages/MentalWealthResources'));
export const AdminMentalWealthEmailDrip = lazy(() => import('@/pages/AdminMentalWealthEmailDrip'));
export const AdminFeatureFlags = lazy(() => import('@/pages/AdminFeatureFlags'));

// ===================== LEARNING / AI =====================
export const LearningDashboard = lazy(() => import('@/pages/LearningDashboard'));
export const ModuleDetail = lazy(() => import('@/pages/ModuleDetail'));
export const CohortEnrollment = lazy(() => import('@/pages/CohortEnrollment'));
export const EnrollmentSuccess = lazy(() => import('@/pages/EnrollmentSuccess'));
export const AICurriculum = lazy(() => import('@/pages/AICurriculum'));
export const AIFundamentals = lazy(() => import('@/pages/AIFundamentals'));
export const MentorDirectory = lazy(() => import('@/pages/MentorDirectory'));
export const Messages = lazy(() => import('@/pages/Messages'));
export const AIGeneralistPricing = lazy(() => import('@/pages/AIGeneralistPricing'));
export const AIGeneralistRoadmap = lazy(() => import('@/pages/AIGeneralistRoadmap'));
export const AIToolsDirectory = lazy(() => import('@/pages/AIToolsDirectory'));
export const AllTools = lazy(() => import('@/pages/AllTools'));
export const LaunchDay1 = lazy(() => import('@/pages/LaunchDay1'));
export const PremiumAIDashboard = lazy(() => import('@/pages/PremiumAIDashboard'));
export const AIGeneralistLevel = lazy(() => import('@/pages/AIGeneralistLevel'));

// ===================== TOOLS & MARKETPLACE =====================
export const ProfessionalServices = lazy(() => import('@/pages/ProfessionalServices'));
export const ServiceOrderForm = lazy(() => import('@/pages/ServiceOrderForm'));
export const CapitalReadinessHub = lazy(() => import('@/pages/CapitalReadinessHub'));
export const CapitalMarketplace = lazy(() => import('@/pages/CapitalMarketplace'));
export const ServiceProviderMarketplace = lazy(() => import('@/pages/ServiceProviderMarketplace'));
export const EnterprisePortal = lazy(() => import('@/pages/EnterprisePortal'));
export const RetailLaunchpad = lazy(() => import('@/pages/RetailLaunchpad'));
export const BusinessFormationWizard = lazy(() => import('@/pages/BusinessFormationWizard'));
export const PermitLookup = lazy(() => import('@/pages/PermitLookup'));
export const TestYourKnowledge = lazy(() => import('@/pages/TestYourKnowledge'));

// ===================== COMMUNITY & PROOF =====================
export const Forum = lazy(() => import('@/pages/Forum'));
export const ForumCategory = lazy(() => import('@/pages/ForumCategory'));
export const ForumPost = lazy(() => import('@/pages/ForumPost'));
export const ForumNewPost = lazy(() => import('@/pages/ForumNewPost'));
export const BadgesPage = lazy(() => import('@/pages/BadgesPage'));
export const VolunteerHub = lazy(() => import('@/pages/VolunteerHub'));
export const Proof = lazy(() => import('@/pages/Proof'));
export const ProofDashboard = lazy(() => import('@/pages/ProofDashboard'));
export const CreateCommitment = lazy(() => import('@/pages/CreateCommitment'));
export const CommitmentDetail = lazy(() => import('@/pages/CommitmentDetail'));
export const ProofSquads = lazy(() => import('@/pages/ProofSquads'));
export const ProofApply = lazy(() => import('@/pages/ProofApply'));
export const ProofEthics = lazy(() => import('@/pages/ProofEthics'));
export const ProofScoreboard = lazy(() => import('@/pages/ProofScoreboard'));
export const CohortDashboard = lazy(() => import('@/pages/CohortDashboard'));
export const ProofPassport = lazy(() => import('@/pages/ProofPassport'));
export const ProofVerify = lazy(() => import('@/pages/ProofVerify'));
export const ProofLandingPage = lazy(() => import('@/pages/ProofLandingPage'));
export const ProofResiliencePathway = lazy(() => import('@/pages/ProofResiliencePathway'));
export const ResilienceWall = lazy(() => import('@/pages/ResilienceWall'));
export const WinWall = lazy(() => import('@/pages/WinWall'));
export const GrantTracker = lazy(() => import('@/pages/GrantTracker'));
export const SkillsBarter = lazy(() => import('@/pages/SkillsBarter'));
export const NextStep = lazy(() => import('@/pages/NextStep'));
export const DowUrkScore = lazy(() => import('@/pages/DowUrkScore'));
export const PublicProfile = lazy(() => import('@/pages/PublicProfile'));
export const LaunchRoadmap = lazy(() => import('@/pages/LaunchRoadmap'));
export const LaunchCalculator = lazy(() => import('@/pages/LaunchCalculator'));
export const CertificationTracker = lazy(() => import('@/pages/CertificationTracker'));
export const NonprofitGrants = lazy(() => import('@/pages/NonprofitGrants'));
export const BusinessPlan = lazy(() => import('@/pages/BusinessPlan'));
export const LenderMatch = lazy(() => import('@/pages/LenderMatch'));
export const BusinessStructure = lazy(() => import('@/pages/BusinessStructure'));
export const DowUrkGrantsDashboard = lazy(() => import('@/pages/DowUrkGrantsDashboard'));
export const Nonprofits = lazy(() => import('@/pages/Nonprofits'));
export const ProofForCohorts = lazy(() => import('@/pages/ProofForCohorts'));
export const ProofFreeTier = lazy(() => import('@/pages/ProofFreeTier'));
export const EmbedKit = lazy(() => import('@/pages/EmbedKit'));
export const NonprofitProfile = lazy(() => import('@/pages/NonprofitProfile'));
export const NonprofitDirectory = lazy(() => import('@/pages/NonprofitDirectory'));
export const NonprofitSignup = lazy(() => import('@/pages/NonprofitSignup'));
export const NeedsAssessment = lazy(() => import('@/pages/NeedsAssessment'));
export const DowUrkImpact = lazy(() => import('@/pages/DowUrkImpact'));
export const StartANonprofit = lazy(() => import('@/pages/StartANonprofit'));
export const NonprofitAdvocacy = lazy(() => import('@/pages/NonprofitAdvocacy'));
export const Give = lazy(() => import('@/pages/Give'));
export const OrgProfile = lazy(() => import('@/pages/OrgProfile'));
export const Pricing = lazy(() => import('@/pages/Pricing'));
export const AdminCredentials = lazy(() => import('@/pages/admin/AdminCredentials'));
export const Verify = lazy(() => import('@/pages/Verify'));
export const VerifyDossier = lazy(() => import('@/pages/VerifyDossier'));
export const GrantScout = lazy(() => import('@/pages/GrantScout'));
export const AdminGrantScout = lazy(() => import('@/pages/admin/AdminGrantScout'));
export const NonprofitImpact = lazy(() => import('@/pages/NonprofitImpact'));
export const Simulators = lazy(() => import('@/pages/Simulators'));
export const AdminGrants = lazy(() => import('@/pages/admin/AdminGrants'));
export const PitchPractice = lazy(() => import('@/pages/PitchPractice'));
export const AdminNextStepLeaderboard = lazy(() => import('@/pages/admin/AdminNextStepLeaderboard'));
export const AdminResilienceFunnel = lazy(() => import('@/pages/AdminResilienceFunnel'));
export const AdminCypTelemetry = lazy(() => import('@/pages/AdminCypTelemetry'));
export const AdminTopTasks = lazy(() => import('@/pages/AdminTopTasks'));
export const YouthTrack = lazy(() => import('@/pages/YouthTrack'));
export const CommunityTrack = lazy(() => import('@/pages/CommunityTrack'));
export const SevenFsMethodology = lazy(() => import('@/pages/SevenFsMethodology'));
export const ResourceLibrary = lazy(() => import('@/pages/ResourceLibrary'));

// ===================== DASHBOARD / USER =====================
export const Dashboard = lazy(() => import('@/pages/Dashboard'));
export const MasterDashboard = lazy(() => import('@/pages/MasterDashboard'));
export const BadgeProgressDashboard = lazy(() => import('@/pages/BadgeProgressDashboard'));
export const AccountSettings = lazy(() => import('@/pages/AccountSettings'));
export const OrganizationManagement = lazy(() => import('@/pages/OrganizationManagement'));
export const APIAccessManagement = lazy(() => import('@/pages/APIAccessManagement'));
export const NotificationCenter = lazy(() => import('@/pages/NotificationCenter'));
export const SubscriptionAnalytics = lazy(() => import('@/pages/SubscriptionAnalytics'));
export const BusinessAnalytics = lazy(() => import('@/pages/BusinessAnalytics'));
export const PremiumCalendar = lazy(() => import('@/pages/PremiumCalendar'));
export const PledgePage = lazy(() => import('@/pages/PledgePage'));
export const OurPledgePage = lazy(() => import('@/pages/OurPledgePage'));

// ===================== DISASTER & VETERANS =====================
export const DisasterHub = lazy(() => import('@/pages/DisasterHub'));
export const VeteransSupport = lazy(() => import('@/pages/VeteransSupport'));
export const EmergencyResourcesMap = lazy(() => import('@/pages/EmergencyResourcesMap'));
export const EmergencyAlerts = lazy(() => import('@/pages/EmergencyAlerts'));
export const RecoveryNavigator = lazy(() => import('@/pages/RecoveryNavigator'));
export const DisasterPreparedness = lazy(() => import('@/pages/DisasterPreparedness'));
export const VolunteerPortal = lazy(() => import('@/pages/VolunteerPortal'));
export const GeneralVolunteerPortal = lazy(() => import('@/pages/GeneralVolunteerPortal'));
export const EmergencyContacts = lazy(() => import('@/pages/EmergencyContacts'));
export const WeatherMap = lazy(() => import('@/pages/WeatherMap'));

// ===================== SEVEN F's FRAMEWORK =====================
export const SevenFramework = lazy(() => import('@/pages/SevenFramework'));
export const SevenFPage = lazy(() => import('@/pages/SevenFPage'));

// ===================== FINANCIAL LITERACY =====================
export const FinancialLiteracyHub = lazy(() => import('@/pages/FinancialLiteracyHub'));
export const HealthScoreAssessment = lazy(() => import('@/pages/HealthScoreAssessment'));
export const StatementBuilder = lazy(() => import('@/pages/StatementBuilder'));
export const CourseViewer = lazy(() => import('@/pages/CourseViewer'));

// ===================== STUDIO =====================
export const StudioLayout = lazy(() => import('@/pages/studio/StudioLayout'));
export const StudioDashboard = lazy(() => import('@/pages/studio/StudioDashboard'));
export const StudioVault = lazy(() => import('@/pages/studio/StudioVault'));
export const StudioAI = lazy(() => import('@/pages/studio/StudioAI'));
export const StudioShoots = lazy(() => import('@/pages/studio/StudioShoots'));
export const StudioClients = lazy(() => import('@/pages/studio/StudioClients'));
export const StudioBookings = lazy(() => import('@/pages/studio/StudioBookings'));
export const StudioContracts = lazy(() => import('@/pages/studio/StudioContracts'));
export const StudioInvoices = lazy(() => import('@/pages/studio/StudioInvoices'));
export const StudioScheduler = lazy(() => import('@/pages/studio/StudioScheduler'));
export const BookingRequest = lazy(() => import('@/pages/BookingRequest'));
export const WeatherAlertSettings = lazy(() => import('@/pages/WeatherAlertSettings'));

// ===================== CLIENT PORTAL =====================
export const ClientPortalModule = lazy(() => import('@/pages/portal/ClientPortal'));
